import { LobbyImage } from '@colonist/types';
import { UITopNotificationType } from '../../../shared/scripts/notifications/UINotificationController.ts';
import { createDivIn, createImgIn, createLinkIn, createParagraphIn, setElementInnerText, setElementOnClick } from '../../../shared/scripts/ui_utils/DomUtils.ts';
import { getNotificationIconForType, NotificationContentType } from '../../../shared/scripts/ui_utils/NotificationUtils.ts';
export class UIMNotificationView {
    getNotificationContainer() {
        if (this.type == UITopNotificationType.SocketError) return document.getElementById('m-fullscreen-notification-container');
        return document.getElementById('m-notification-container');
    }
    close() {
        this.notification.remove();
        if (this.removeAction != undefined) this.removeAction();
    }
    hide() {
        this.notification.remove();
    }
    createButton(buttonText, action) {
        if (buttonText == undefined || action == undefined) return;
        const button = createLinkIn(this.textContainer, '', buttonText, 'm-notification-action');
        setElementOnClick(button, ()=>{
            UIMNotificationView.hideStoreGiftOverlay();
            this.close();
            action();
        });
    }
    static hideStoreGiftOverlay() {
        const storeGiftOverlays = document.getElementsByClassName('store-gift-overlay-container');
        if (storeGiftOverlays.length > 0) Array.from(storeGiftOverlays).forEach((overlay)=>overlay.classList.add('hidden'));
    }
    updateText(newText) {
        setElementInnerText(this.textContainer, newText);
    }
    updateRemoveAction(removeAction) {
        this.removeAction = removeAction;
    }
    constructor(title, type, buttonText, action, removeAction, contentType = NotificationContentType.General, showCloseButton = true, duration){
        this.type = type;
        this.contentType = contentType;
        this.removeAction = removeAction;
        this.notificationContainer = this.getNotificationContainer();
        const icon = getNotificationIconForType(this.type);
        const lightningModifier = icon === LobbyImage.Lightning ? ' m-notification--lightning' : '';
        this.notification = createDivIn(this.notificationContainer, `m-notification${lightningModifier}`);
        createImgIn(this.notification, icon, 'm-notification-img');
        this.textContainer = createParagraphIn(this.notification, title, 'm-notification-text');
        this.createButton(buttonText, action);
        if (duration !== undefined) {
            setTimeout(()=>{
                this.close();
            }, duration);
        }
        if (showCloseButton == false) return;
        this.crossImage = createImgIn(this.notification, LobbyImage.XMark, 'm-corner-notification-cross');
        setElementOnClick(this.crossImage, ()=>{
            this.close();
        });
    }
}
